module.exports = "/_next/static/images/ef75230b1036b58b8afbaaae0c2d9806-pregnant-woman@desktop@3x.jpg";